// Mock data para a landing page da autora Luisa Landre

export const authorInfo = {
  name: "Luisa Landre",
  bio: "Luisa Landre é fanfiqueira, canceriana, sul-mato-grossense e foi criada entre o campo e a cidade. É apaixonada por histórias de fantasia com romance, ainda mais se forem sáficas, e acredita que livros com vampiros, lobisomens e bruxas nunca são demais. Também tem um fraco por comédias românticas contemporâneas, em especial as que envolvem esportes. Atualmente, mora em Florianópolis.",
  image: "https://customer-assets.emergentagent.com/job_book-writer-page/artifacts/ijzu9g7r_Captura%20de%20tela%20de%202025-08-16%2017-57-51.png",
  socialMedia: {
    instagram: "https://www.instagram.com/luisalandre/",
    tiktok: "https://www.tiktok.com/@luisaleituras",
    twitter: "https://x.com/luisalandre",
    youtube: "https://www.youtube.com/@Luisaleituras"
  }
};

export const books = [
  {
    id: 1,
    title: "Feras em Campo",
    synopsis: "Como se os novos desafios da vida universitária e de ter de se adaptar ao time de futebol mais prestigiado do país não bastassem, o mundo de Lia vira de ponta-cabeça quando ela descobre que vai ter que enfrentar em campo Martina, sua melhor amiga dos tempos da adolescência, com quem precisou romper a amizade de uma forma nada leve. Para além da rivalidade crescente entre os times, Lia e Martina precisarão lidar com as mágoas do reencontro, o instinto selvagem de lobas malvisto pela sociedade e a latente atração que há anos sentem uma pela outra.",
    cover: "https://customer-assets.emergentagent.com/job_55d4e261-ca9d-4922-8969-e6429b744d93/artifacts/xxnfq5g1_FerasEmCampo_Capa.jpg",
    contentWarning: "Conteúdo adulto",
    blurbs: [
      {
        text: "Lobisomens sáficas jogando futebol no Mato Grosso do Sul? Sim, por favor!",
        author: "Giu Domingues, autora best-seller do romance sáfico Luzes do Norte"
      },
      {
        text: "Feras em campo é o tipo de livro que, quando você começa, precisa devorar de uma vez. A autora constrói uma tensão deliciosa entre as protagonistas enquanto nos leva para o interior de um Mato Grosso do Sul cheio de metamorfos, te colocando no meio de uma disputa esportiva que tem muito mais do que um título em jogo... Estou apaixonada!",
        author: "Isabelle Morais, autora de Tratado sobre tempestades e outros fenômenos extraordinários"
      }
    ],
    links: {
      amazon: "https://amzn.to/42tPCXU",
      skoob: "https://www.skoob.com.br/feras-em-campo-122557693ed122560216.html",
      goodreads: "https://www.goodreads.com/book/show/230146557-feras-em-campo",
      maratona: "https://maratona.social/ed/cm8ivlqrp00q7ju03b5s1376a"
    }
  },
  {
    id: 2,
    title: "As Novas Românticas",
    synopsis: "Rebeca Ferraz acaba de chegar à Espanha para realizar o sonho de jogar pelo Barcelona. Depois de uma Copa do Mundo catastrófica para o Brasil e de ser reconhecida apenas como a ex-namorada de um jogador famoso, ela está pronta para conquistar o seu lugar sob os holofotes e limpar sua reputação. Tudo parece ainda melhor quando ela se vê jogando no mesmo time que Cornelia Ember, a atleta inglesa que ela admira há anos.",
    cover: "https://customer-assets.emergentagent.com/job_book-writer-page/artifacts/5visst4l_As%20novas%20rom%C3%A2nticas%20%28capa%29.jpg",
    contentWarning: "Conteúdo adulto",
    links: {
      amazon: "https://amzn.to/3MXQdMh",
      skoob: "https://www.skoob.com.br/pt/book/122608966",
      goodreads: "https://www.goodreads.com/book/show/243162737-as-novas-rom-nticas",
      maratona: "https://maratona.app/ed/cmh9ind9z00pp04l5d10y608h/sobre"
    }
  },
  {
    id: 3,
    title: "Noturnas e Natalinas",
    synopsis: "Em um mundo em que a existência de vampiros é de conhecimento de todos, as criaturas da noite devem preservar o ar de mistério e elegância que se espera de sua espécie. Mas como fazer isso em um feriado tão brega quanto o Natal? Geraldina, a mais nova das três líderes da Casa Oliveira, enfrenta o seu primeiro desafio: coordenar os preparativos para o Natal e vencer o prêmio de melhor decoração natalina.",
    cover: "https://customer-assets.emergentagent.com/job_55d4e261-ca9d-4922-8969-e6429b744d93/artifacts/oorqeg7j_Noturnas%20e%20Natalinas%20-%20Capa.jpg",
    contentWarning: "Classificação indicativa: +14",
    links: {
      amazon: "https://amzn.to/42v379K",
      skoob: "https://www.skoob.com.br/noturnas-e-natalinas-12059349ed12045141.html",
      goodreads: "https://www.goodreads.com/book/show/59737167-noturnas-e-natalinas",
      maratona: "https://maratona.social/ed/cljr7wncp0000mi088elev2d3"
    }
  },
  {
    id: 4,
    title: "Fios de Sangue",
    synopsis: "A vida noturna era tudo o que Helga conhecia. De uma humana que serve aos vampiros, passou a ser um deles e, finalmente, a governá-los. Foi uma longa jornada até o topo, mas no fim de tudo, ela se viu… sozinha. Entediada. Sem sede. Isso até Dora chegar. Dora, que propôs o desafio de voltarem a caçar humanos como nos velhos tempos e que premiava quem matava o humano certo.",
    cover: "https://customer-assets.emergentagent.com/job_55d4e261-ca9d-4922-8969-e6429b744d93/artifacts/i7fwz86t_Capa%20final.jpg",
    contentWarning: "Classificação indicativa: +16",
    links: {
      amazon: "https://amzn.to/3RzwEJd",
      skoob: "https://www.skoob.com.br/fios-de-sangue-122349160ed122355554.html",
      goodreads: "https://www.goodreads.com/book/show/195794826-fios-de-sangue",
      maratona: "https://maratona.social/ed/cllzlvj0n00fxl90857qqybpy"
    }
  }
];

export const seoKeywords = [
  "luisa landre",
  "feras em campo", 
  "noturnas e natalinas",
  "fios de sangue",
  "escritora sáfica",
  "livros sáficos",
  "romance sáfico",
  "fantasia urbana",
  "vampiros",
  "lobisomens",
  "literatura brasileira",
  "autora brasileira"
];